module.exports = __webpack_public_path__ + "img/Icon-512.a609e379.png";